module.exports = "/_next/static/images/top-96de56868c685c17f9cba5e817e7746c.jpg";